function Footer() {
    return (
        <footer className="footer">
        <div className="main">
          <div id="footerInfoOne">
            <p className="footerP">
              East Tennessee State University<br />
              PO BOX 70300 | Johnson City, TN 37614<br />
              423-439-1000 | <a href="mailto:info@etsu.edu">info@etsu.edu</a>
            </p>
          </div>
          <div id="footerInfoTwo">
            <p>
              Financial Systems and Technology<br />
    PO BOX 70601 | Johnson City, TN 37614<br />
    423-439-5504 | <a href="mailto:sealerd@etsu.edu">sealerd@etsu.edu</a>
            </p>
          </div>
        </div>
        <div className="main clear">
          <div className="privacy">
            <span>East Tennessee State University</span>&nbsp; &copy;&nbsp; 2024&nbsp; all rights reserved &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            <a href="https://www.etsu.edu/ehome/documents/webprivacystatement.pdf">privacy policy</a>&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
          </div>
        </div>
      </footer>
    );
}

export default Footer;